import { environment } from '../config/environment';
import { getMethod, postMethod } from './_helper';

const selfUrl = environment.apilUrl;

export const authServ = {
  signin,
  redirect,
  signout
};

async function signin(params) {
  return getMethod(`${selfUrl}/signin`, params)
}

async function redirect(params) {
  console.log(params);
  return getMethod(`${selfUrl}/redirect`, params)
}

async function signout(params) {
  return getMethod(`${selfUrl}/signout`, params)
}